import { OwcHyperlink, OwcTypography, OwcIcon, OwcTooltip } from "@one/react";
import { react18WorkaroundProps } from "../utils/constants/constants";
import { GoogleAuth } from "../components/shared/GoogleAuth";

const GRID_HOME_TOOLTIP = "Click to go to GRID Home and change site, then click refresh";
const REFRESH_TOOLTIP = "If you have recently changed site, click to refresh";

const UserProfile = ({ user, isBookingAdmin }) => {
  const openGridHome = () => {
    const url = new URL(process.env.REACT_APP_LP_GRAPHQL_ENDPOINT_CLOUDFRONT);
    url.searchParams.set("source", "booking");
    window.open(url.toString(), "_blank", "noopener,noreferrer");
  };
  const refreshPage = () => {
    window.location.reload();
  };
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', padding: '3px 16px', borderTop: "thin solid #C2BAB5" }}>
        <GoogleAuth showCalendarIcon={true} />
      </div>
      <div style={{ borderTop: "thin solid #C2BAB5", padding: "10px 16px", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <OwcIcon
            id="icon-warning"
            type="outlined"
            name="notification"
            style={{ margin: '0 4px' }}
            {...react18WorkaroundProps}
          />
          <OwcHyperlink href={process.env.REACT_APP_LP_GRAPHQL_ENDPOINT_CLOUDFRONT + "notificationsApp"} target="_blank" style={{ color: 'var(--one-color-foreground-base-1)', cursor: 'pointer', fontWeight: 'normal', textDecoration: 'none' }}>
            Notification settings
          </OwcHyperlink>
        </div>
      </div>
      <div style={{ borderTop: "thin solid #C2BAB5", padding: "3px 16px", backgroundColor: "#FBFBFA", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <OwcTypography style={{ color: '#9D948E', fontSize: "12px", marginLeft: "9px", lineHeight: "normal" }}>Site</OwcTypography>
          <OwcTypography style={{ color: '#9D948E', fontSize: "16px", marginLeft: "9px", lineHeight: "normal" }}>{user.site}</OwcTypography>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: '9px' }}>
          <OwcIcon
            id="icon-go-to-grid-home"
            type="legacy"
            name="launch"
            onClick={openGridHome}
            data-testid="go-to-grid-home-icon"
            aria-label="Go to GRID Home"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openGridHome(); } }}
            style={{ cursor: 'pointer', color: 'var(--one-color-foreground-base-1)' }}
            {...react18WorkaroundProps}
          />
          <OwcTooltip anchor="icon-go-to-grid-home" placement="bottom">
            {GRID_HOME_TOOLTIP}
          </OwcTooltip>
          <OwcIcon
            id="icon-refresh-site"
            type="legacy"
            name="refresh"
            onClick={refreshPage}
            data-testid="refresh-button"
            aria-label="Refresh page"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); refreshPage(); } }}
            style={{ cursor: 'pointer', color: 'var(--one-color-foreground-base-1)' }}
            {...react18WorkaroundProps}
          />
          <OwcTooltip anchor="icon-refresh-site" placement="bottom">
            {REFRESH_TOOLTIP}
          </OwcTooltip>
        </div>
      </div>
      <div style={{ borderTop: "thin solid #C2BAB5", borderBottom: "thin solid #C2BAB5", padding: "3px 16px", backgroundColor: "#FBFBFA" }}>
        <OwcTypography style={{ color: '#9D948E', fontSize: "12px", marginLeft: "9px", lineHeight: "normal" }}>Role</OwcTypography>
        <OwcTypography style={{ color: '#9D948E', fontSize: "16px", marginLeft: "9px", lineHeight: "normal" }}>{isBookingAdmin ? "Admin" : "User"}</OwcTypography>
      </div>
    </>
  );
};

export default UserProfile;
